<template>
  <div>
      <div class="dialog-container">
        <div class="selected-list">
          已选品牌：<span v-for="item,index in selectList" :key="index">{{item.brandName}} <i v-if="index !== selectList.length - 1">、</i> </span>
        </div>
        <div class="search-row">
          <div class="search-form">
            品牌
            <el-input v-model="brandParams.brandName" placeholder="请输入品牌名称" clearable></el-input>
          </div>
          <div class="handle-box">
            <el-button class="btn btn-red" @click="search">搜索</el-button>
            <el-button class="btn btn-reset" @click="resetSearch">重置</el-button>
          </div>
        </div>
        <!-- 数据列表 -->
        <el-table
          :data="brandList"
          border
          :row-key="brandRowKey"
          @select="getSelectBrand"
          @select-all="selectAllBrand"
          class="dialog-table"
          ref="brandTable"
        >
          <el-table-column align="center" prop="brandName" label="品牌" min-width="50%" />
          <el-table-column
            align="center"
            type="selection"
            :reserve-selection="true"
            width="200px"
            min-width="50%"
          />
        </el-table>
        <el-row class="while-data-table-footer" v-if="brandList.length">
          <el-col>
            <el-pagination
              background
              :current-page="brandParams.page"
              :page-size="brandParams.pageSize"
              :total="brandParams.total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade.js'
// import { mapGetters } from 'vuex'
export default {
  props: {
    selectedList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      brandParams: {
        brandName: '',
        page: 1,
        pageSize: 10,
        total: 0
      },
      brandList: [],
      selectList: [], // 已勾选品牌列表
      selectedBrandList: [],
      tmpList: []
    }
  },
  watch: {
    selectedList () {
      this.selectList = JSON.parse(JSON.stringify(this.selectedList)) || []
      this.showBrandSelected()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.search()
      this.selectList = JSON.parse(JSON.stringify(this.selectedList)) || []
      this.showBrandSelected()
    },
    // 搜索
    search () {
      this.brandParams.page = 1
      this.getBrandList()
    },
    // 获取品牌列表
    getBrandList () {
      tradeApi.getStrBrand(this.brandParams).then(res => {
        if (res.data.resultCode === '0') {
          this.brandParams.total = res.data.resultData.pageInfo.totalCounts
          this.brandList = res.data.resultData.brandList || []
          this.showBrandSelected()
        }
      })
    },
    // 重置搜索条件
    resetSearch () {
      this.brandParams = this.$options.data().brandParams
      this.getBrandList()
    },
    // 品牌列表分页
    handleCurrentChange (val) {
      this.brandParams.page = val
      this.getBrandList()
    },
    // sku弹窗每行标志位
    brandRowKey (row) {
      return row.brandCode
    },
    // 已勾选 表格对应展示
    showBrandSelected () {
      this.$nextTick(() => {
        this.brandList.map(brand => {
          const matchedBrand = this.selectList.find(selectedBrand => {
            return selectedBrand.brandCode === brand.brandCode
          })
          this.$refs.brandTable.toggleRowSelection(brand, Boolean(matchedBrand))
        })
      })
    },
    // 选择赠酒SKU
    getSelectBrand (selectList, row) {
      let flag = this.selectList.some((item) => {
        return item.brandCode === row.brandCode
      })
      if (flag) {
        this.selectList.forEach((item, index) => {
          if (item.brandCode === row.brandCode) {
            this.selectList.splice(index, 1)
          }
        })
      } else {
        this.selectList.push(row)
      }
      this.$emit('strBrand', this.selectList)
    },
    // 赠酒sku全选
    selectAllBrand (selectList) {
      this.selectList = Object.assign([], selectList)
      this.$emit('strBrand', this.selectList)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  .selected-list {
    line-height: 40px;
    color: #000;
  }
  .search-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.el-input,
.el-select {
  width: 150px;
  margin: 0 20px 0 10px;
  &::v-deep .el-input__inner {
    height: 30px;
  }
}
.el-button {
  width: 80px;
  height: 30px;
  padding: 0 20px;
}
.dialog-table {
  ::v-deep .el-table__header-wrapper .el-checkbox__input::after {
    content: '全选';
    position: absolute;
    margin: 0 0 0 10px;
    font-weight: 700;
    color: rgb(144, 147, 153);
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>
